import { em } from 'polished'
import styled, { css } from 'styled-components'

import DynamicImage from 'components/DynamicImage'
import { setBackground } from 'utils/styled/setBackground'

export const Wrapper = styled.div`
  // height: ${em(320)};
  margin: 0 auto;
  max-width: 90%;
  position: relative;
  width: ${em(420)};
  // margin-top: -${em(50)};
  // margin-bottom: -${em(30)};

  ${p => p.theme.mq.upMd} {
    background-position: 0 0;
    max-width: 100%;
    width: ${em(350)};
    height: ${em(320)};
    margin-top: 0;
    margin-bottom: 0;
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(469)};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  display: block;
  max-width: ${em(350)};
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    height: inherit;
    object-position: left top;
    max-width: initial;
    margin: 0;
  }
`

export const Shadow = styled.div`
  background: 0 100% / contain no-repeat;
  ${p => setBackground('png', p.image, { md: 360 }, false)};
  bottom: ${em(-40)};
  display: none;
  height: 100%;
  left: -27%;
  opacity: 0.7;
  position: absolute;
  width: 130%;

  ${p => p.theme.mq.upMd} {
    display: block;
  }

  ${p => p.theme.mq.upLg} {
    bottom: ${em(-125)};
  }
`

export const IconWrapper = styled.div`
  display: none;
  position: absolute;

  ${({ isFirstGuy }) =>
    isFirstGuy &&
    css`
      bottom: ${em(-110)};
      height: ${em(220)};
      left: ${em(11)};
      width: ${em(137)};
    `}

  ${({ isFirstGuy }) =>
    !isFirstGuy &&
    css`
      bottom: ${em(-82)};
      height: ${em(192)};
      right: ${em(2)};
      width: ${em(137)};
    `}

  ${p => p.theme.mq.upLg} {
    display: block;
  }

`
